// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';

export const buildUser = ({ userId }) => ({
  dyid: userId,
  dyid_server: userId,
});

export const buildSession = (sessionId) => ({
  dy: sessionId,
});

export const buildPageContext = ({ type, location, locale = 'en_US', data = [], referrer }) => ({
  type,
  location,
  locale,
  data: data.length ? data : [],
  referrer: referrer || window?.location?.href || location,
});

export const buildDeviceContext = ({ userAgent, ip, dateTime = new Date().toISOString() }) => ({
  userAgent,
  ip,
  dateTime,
});

export const buildContext = ({ page, device, channel = 'WEB', pageAttributes }) => ({
  page,
  device,
  channel,
  ...(isEmpty(pageAttributes) ? {} : { pageAttributes }),
});

export const buildTrackEventContext = ({ device, channel = 'WEB' }) => ({
  device,
  channel,
});

export const buildSelector = (groups = []) => ({
  groups,
});

export const buildEngagements = (recSlotId, decsId) => [
  {
    type: 'SLOT_CLICK',
    slotId: recSlotId,
    decisionId: decsId,
  },
];

export const buildOptions = ({
  isImplicitPageview = false,
  returnAnalyticsMetadata = true,
  isImplicitImpressionMode = true,
  isImplicitClientData = false,
} = {}) => ({
  isImplicitPageview,
  returnAnalyticsMetadata,
  isImplicitImpressionMode,
  isImplicitClientData,
});
